export default __webpack_public_path__ + "static/media/boys-bottom.ed1245ed.png";